import { Meta } from '@/components/common';
import { Container } from '@/components/layout';
import { LogTable } from '@/components/features/logs';

export function LogsPage() {
  return (
    <>
      <Meta title="Logs" />

      <Container className="space-y-6">
        <p className="text-[12.5px] text-muted-foreground">
          Errors the desktop clients have reported in the last 90 days. The full log files are
          backed up to S3 and kept for 90 days too.
        </p>
        <LogTable />
      </Container>
    </>
  );
}
